import { FormAccessibility } from 'components/user/user-detail/tab-profile/FormAccessibility'
import { useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { constructOptionsSelect, deepClone } from 'utils/utils'
import { useDispatch, useSelector } from 'react-redux'
import { setIsReload } from 'reducers/userReducer'
import { Alert } from 'avo-ui'

export const FormAccessibilityContainer = ({ show, onHide }) => {
    const dispatch = useDispatch()
    const { userDetails } = useSelector((state) => state.userReducer)
    const [dataAccessibility, setDataAccessibility] = useState(userDetails?.accessibility)
    const { data: roleList } = useFetch(API_USER.ROLE_LIST, {}, { isFetching: true })
    const { fetching: updateUserDetailApi, isLoading } = useFetch(API_USER.UPDATE)

    const onChangeForm = (e) => {
        let newData = {}
        if (e.name === 'role') {
            newData.name = e.value.label
            newData.role_id = e.value.value
        } else {
            newData.status = e.checked ? 'active' : 'inactive'
        }
        setDataAccessibility({ ...dataAccessibility, ...newData })
    }

    const onSubmit = async () => {
        let payload = deepClone(dataAccessibility)
        payload.name = userDetails?.profile?.name
        await updateUserDetailApi(payload, userDetails?.profile?.id)
        dispatch(setIsReload())
        onHide()
        return Alert({
            icon: 'success',
            title: 'Success',
            message: 'Access Updated !',
        })
    }

    const props = {
        dataAccessibility,
        show,
        onHide,
        dataRole: roleList?.data ? constructOptionsSelect(roleList?.data, 'name', 'id') : [],
        isLoading,
        onChangeForm,
        onSubmit,
    }

    return <FormAccessibility {...props} />
}
